module.exports = __webpack_public_path__ + "static/media/435.26ca8dd8.png";